// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { ResourceTypeManagerSite_abstract } from './../abstract/SagaSchema/ResourceTypeManagerSite_abstract';
export class ResourceTypeManagerSite extends ResourceTypeManagerSite_abstract {}
